import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";
import "./Footer.css";
import { useNavigate ,Link} from "react-router-dom";
import logo from '../Images/Jayraj_logo.png'

function Footer() {
  const navigate = useNavigate()
  return (
    <motion.footer 
      className="footer"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="footer-container">

        {/* Brand Column */}
        <div className="footer-col">
           <img src={logo} alt="Jayraj Group Logo" width="100px" height="100px"/>
        
          <p className="footer-desc">
            <strong>Jayraj Group</strong> Building dreams, creating value.<br/>
            Your trusted partner in premium Jayraj Group.
          </p>
            <h3 className="footer-logo"></h3>
         
        </div>

        {/* Quick Links */}
        <div className="footer-col" style={{display:"flex",flexDirection:"column"}}>
          <h4 className="footer-heading">QUICK LINKS</h4>
          <div className="quicklinks">
          <ul>
            {/* <li><Link to="/">Home</Link></li> */}
            <li><Link to="/tour/grouptour">Group Tour</Link></li>
            <li><Link to="/tour/packagetour">Package Tour</Link></li>
            <li><Link to="/tour/plantour">Plan Tour</Link></li>
            <li><Link to="/tour/weekendtour">Weekend Tour</Link></li>

          </ul>
          <ul>
            <li><Link to="/hotels">Hotels</Link></li>
            <li><Link to="/activities">Activity</Link></li>
            <li><Link to="/transports">Transport</Link></li>
            <li><Link to="/become-partner">Become a Partner</Link></li>
          </ul>
          </div>

        </div>

        {/* Legal */}
        <div className="footer-col">
          <h4 className="footer-heading">LEGAL</h4>
          <ul>
            <li><a href="/">Privacy Policy</a></li>
            <li><a href="/">Terms of Service</a></li>
            <li><a href="/">Disclaimer</a></li>
            <li><a href="/awards">Certificates</a></li>
          </ul>
        </div>

        {/* Social */}
        <div className="footer-col">
          <h4 className="footer-heading">FOLLOW US</h4>
          <div className="social-icons1">
            <a href="/"><FaFacebookF /></a>
            <a href="/"><FaTwitter /></a>
            <a href="/"><FaLinkedinIn /></a>
            <a href="/"><FaInstagram /></a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © 2025 Jayraj Group . All rights reserved.
      </div>
    </motion.footer>
  );
}

export default Footer;
